import { render, staticRenderFns } from "./QuantizationPlayground.vue?vue&type=template&id=2251b246&scoped=true&"
import script from "./QuantizationPlayground.vue?vue&type=script&lang=js&"
export * from "./QuantizationPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251b246",
  null
  
)

export default component.exports